import styled from 'styled-components';

export const Articles = styled.div``

export const Content = styled.div`
  padding: 5%;
  max-width: 1000px;
  margin: 0 auto;
`
